import { c as _c } from "react/compiler-runtime";
import { Divider } from '@7f-ui/components/divider/divider';
import { Star } from '@phosphor-icons/react';
import { formatGermanNumber } from '@utils/utils-format';
import { RatingBreakdown } from './rating-breakdown';
type RatingSummaryProps = {
  average: number;
  totalReviews: number;
  breakdown: [number, number, number, number, number];
};
const RATING_LABELS = ['na', 'Mangelhaft', 'Ausreichend', 'Befriedigend', 'Gut', 'Sehr gut'];
export function RatingSummary(t0) {
  const $ = _c(15);
  const {
    average,
    totalReviews,
    breakdown
  } = t0;
  const ratingLabel = RATING_LABELS[Math.round(average)] ?? "na";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-warning"><Star weight="fill" className="size-8" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `${average} · ${ratingLabel}`;
  let t3;
  if ($[1] !== t2) {
    t3 = <div className="font-body-small font-semibold">{t2}</div>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = totalReviews === 1 ? "Basiert auf einer Bewertung" : `Basiert auf ${formatGermanNumber(totalReviews)} Bewertungen`;
  let t5;
  if ($[3] !== t4) {
    t5 = <div className="font-body-small">{t4}</div>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3 || $[6] !== t5) {
    t6 = <div className="flex items-center gap-2">{t1}<div>{t3}{t5}</div></div>;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Divider />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== breakdown || $[10] !== totalReviews) {
    t8 = <RatingBreakdown breakdown={breakdown} totalReviews={totalReviews} variant="five-stars" />;
    $[9] = breakdown;
    $[10] = totalReviews;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6 || $[13] !== t8) {
    t9 = <section aria-label={"Bewertungs\xFCbersicht"} className="grid w-full gap-6">{t6}{t7}{t8}</section>;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}